class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.overlay = this.querySelector('.details-modal-overlay');
    this.closeButton = this.querySelector('.modal__close-button');

    if (!this.detailsContainer || !this.summaryToggle) return;

    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    /* ===============================
       ESC 关闭
    =============================== */
    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') {
        this.close();
      }
    });

    /* ===============================
       iOS / 其他设备 事件分离
    =============================== */
    if (this.isIOS) {
      this.summaryToggle.addEventListener(
        'touchend',
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.onSummaryClick(event);
        },
        { passive: false }
      );
    } else {
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );
    }

    /* ===============================
       关闭按钮
    =============================== */
    if (this.closeButton) {
      this.closeButton.addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    /* ===============================
       遮罩关闭
    =============================== */
    if (this.overlay) {
      this.overlay.addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    /* ===============================
       搜索打开时，hover mega-menu 自动关闭
    =============================== */
    this.handleMegaMenuEnter = (event) => {
      if (!this.isOpen()) return;

      if (
        event.target &&
        event.target.closest &&
        event.target.closest('details.mega-menu')
      ) {
        this.close(false);
      }
    };

    document.addEventListener(
      'mouseenter',
      this.handleMegaMenuEnter,
      true
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  /* ===============================
     状态判断
  =============================== */
  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  /* ===============================
     点击 summary
  =============================== */
  onSummaryClick(event) {
    event.preventDefault();

    const details = event.target.closest('details');
    if (!details) return;

    details.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  /* ===============================
     打开
  =============================== */
  open(event) {
    if (event) {
      const searchEl = event.target.closest('.header-search-icon');

      if (searchEl) {
        const headerMenu = document.querySelector(
          '#header-drawer-menu-mobile .header__icon[aria-expanded="true"]'
        );

        headerMenu?.click();

        document.documentElement.classList.add(
          `overflow-hidden-${this.dataset.breakpoint}`
        );
      }

      event.target.closest('details').setAttribute('open', true);
    }

    document.body.classList.add(
      `overflow-hidden-${this.dataset.breakpoint}`
    );

    // ✅ 延迟 focus，避免 iOS 自动缩放
    setTimeout(() => {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector(
          'input:not([type="hidden"])'
        )
      );
    }, this.isIOS ? 60 : 0);
  }

  /* ===============================
     关闭
  =============================== */
  close(focusToggle = true) {
    removeTrapFocus(
      focusToggle ? this.summaryToggle : null
    );

    this.detailsContainer.removeAttribute('open');

    const searchEl =
      this.detailsContainer.closest('.header-search-icon');

    if (searchEl) {
      document.documentElement.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
    }

    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
  }

  /* ===============================
     销毁
  =============================== */
  disconnectedCallback() {
    if (this.handleMegaMenuEnter) {
      document.removeEventListener(
        'mouseenter',
        this.handleMegaMenuEnter,
        true
      );
    }
  }
}

customElements.define('details-modal', DetailsModal);